'use strict';
module.exports = require('./Menu.vue');